// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e4PG","rootNoMargin":"styles_rootNoMargin__1zzZm"};